import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";

export default function CustomPreApprove2ReminderDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <React.Fragment>
      <Button
        id="btn-application-preapprove-reminder"
        label="Reminder"
        variant="contained"
        size="medium"
        color="primary"
        sx={{
          marginLeft: "10px",
          width: "120px",
          "&:hover": { bgcolor: "gray" },
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-preapprove-reminder"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="xs"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const reqUrl = `email/reminder/preapprove`;
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: {},
            });
            if (
              response &&
              (response.status == "200" || response.code == "200")
            ) {
              successNotify("Message sent successfully.");
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Reminder" />
        </DialogTitle>
        <DialogContent>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          <DialogContentText>
            {/* Send a message to remind the applicant to respond to the pre-approval offer. */}
            Resend the email and message to applicant to remind them to review
            the offer.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Reminder" color="primary" />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
